import React from "react";

// Tus componentes
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import Typography from "@material-ui/core/Typography";

const HEADER_COLOR = "#13816F"; // principal
const HEADER_LIGHT = "#CDE8E3"; // derivado
const HEADER_LIGHTER = "#E7F4F1"; // más claro

export default function ReportPolicies({
  title = "",
  infos = [],
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  const now = new Date().toLocaleString();

  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      {/* Hidden fields */}
      <form id="report_form">
        {Object.entries(forma).map(([name, value]) => (
          <input key={name} type="hidden" name={name} value={value} readOnly />
        ))}
      </form>

      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "white", borderRadius: 8 }}
            >
              {/* Header */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={12} md={6}>
                  <Typography variant="h6">
                    {report_tz &&
                      `${timezones[report_tz]} - ${report_tz.toUpperCase()}`}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(7, "pdf")}
                        sx={{ ml: 2 }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(7, "csv")}
                        sx={{ ml: 2 }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        color="success"
                        style={{
                          backgroundColor: "#FFF",
                          borderColor: "#13816F",
                          color: "#13816F",
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>

              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {now}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20, marginTop: -10 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>

              {/* MULTIPLE TABLES PER AGENCY */}
              {Object.entries(infos).map(([key, info], index) => (
                <TableContainer
                  component={Paper}
                  key={index}
                  style={{ marginBottom: 40 }}
                >
                  <Table size="small">
                    {/* Header Agency */}
                    <TableHead>
                      <TableRow>
                        <TableCell
                          colSpan={32}
                          style={{
                            background: HEADER_COLOR,
                            color: "#FFF",
                            fontWeight: "bold",
                            fontSize: "1.1rem",
                          }}
                        >
                          Agency
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          colSpan={2}
                          style={{ background: HEADER_LIGHTER }}
                        >
                          {info.agency.code}
                        </TableCell>
                        <TableCell
                          colSpan={30}
                          style={{ background: HEADER_LIGHTER }}
                        >
                          {info.agency.name}
                        </TableCell>
                      </TableRow>

                      {/* Columns */}
                      <TableRow style={{ background: HEADER_LIGHT }}>
                        <TableCell>First Name</TableCell>
                        <TableCell>Last Name</TableCell>
                        <TableCell>Additional Insured</TableCell>
                        <TableCell>Address</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>State</TableCell>
                        <TableCell>Zip Code</TableCell>
                        <TableCell>Phone #</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Policy Number</TableCell>
                        <TableCell>Time Zone</TableCell>
                        <TableCell>IssueDate</TableCell>
                        <TableCell>StartDate</TableCell>
                        <TableCell>ExpDate</TableCell>
                        <TableCell>Policy Days</TableCell>
                        <TableCell>Customer</TableCell>
                        <TableCell>Repeat</TableCell>
                        <TableCell>Destination</TableCell>
                        <TableCell>VehicleType</TableCell>
                        <TableCell>VehicleYr</TableCell>
                        <TableCell>VehicleMake</TableCell>
                        <TableCell>VehicleModel</TableCell>
                        <TableCell>Have lienholder</TableCell>
                        <TableCell>LienHolder</TableCell>
                        <TableCell>InsuredValue</TableCell>
                        <TableCell>Net premium</TableCell>
                        <TableCell>Policy Fee</TableCell>
                        <TableCell>User</TableCell>
                        <TableCell>Csl Limit</TableCell>
                        <TableCell>Territorial extension</TableCell>
                        <TableCell>Border Crossing</TableCell>
                        <TableCell>Preferred Language</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {info.details.map((row, i) => (
                        <TableRow key={i}>
                          <TableCell>{row.first_name}</TableCell>
                          <TableCell>{row.last_name}</TableCell>
                          <TableCell>{row.additional_insured}</TableCell>
                          <TableCell>{row.address}</TableCell>
                          <TableCell>{row.city}</TableCell>
                          <TableCell>{row.state_name}</TableCell>
                          <TableCell>{row.zipcode}</TableCell>
                          <TableCell>{row.phone}</TableCell>
                          <TableCell>{row.email}</TableCell>
                          <TableCell>{row.policy_nbr}</TableCell>
                          <TableCell>{row.time_zone_name}</TableCell>
                          <TableCell>
                            {new Date(row.issue_date).toLocaleDateString()}
                          </TableCell>
                          <TableCell>
                            {new Date(row.effective_date).toLocaleDateString()}
                          </TableCell>
                          <TableCell>
                            {new Date(row.expiration_date).toLocaleDateString()}
                          </TableCell>
                          <TableCell>{row.days}</TableCell>
                          <TableCell>{row.customer}</TableCell>
                          <TableCell>{row.repeat > 0 ? "Yes" : "No"}</TableCell>
                          <TableCell>{row.destination}</TableCell>
                          <TableCell>{row.vehicle_type_name}</TableCell>
                          <TableCell>{row.year_model}</TableCell>
                          <TableCell>{row.make}</TableCell>
                          <TableCell>{row.model}</TableCell>
                          <TableCell>{row.lienholder ? "Yes" : "No"}</TableCell>
                          <TableCell>{row.lienholder}</TableCell>
                          <TableCell>
                            ${Number(row.total_value).toLocaleString()}
                          </TableCell>
                          <TableCell>
                            $
                            {Number(row.revised_net_premium).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                              }
                            )}
                          </TableCell>
                          <TableCell>
                            $
                            {Number(row.policy_fee).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </TableCell>
                          <TableCell>{row.username}</TableCell>
                          <TableCell>{row.csllimit}</TableCell>
                          <TableCell>{row.ter_ext}</TableCell>
                          <TableCell>{row.border_crossing_name}</TableCell>
                          <TableCell>{row.preferred_language}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ))}

              {/* Bottom buttons */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={12} md={6}>
                  &nbsp;
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(7, "pdf")}
                        sx={{ ml: 2 }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(7, "csv")}
                        sx={{ ml: 2 }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        color="success"
                        style={{
                          backgroundColor: "#FFF",
                          borderColor: "#13816F",
                          color: "#13816F",
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
